module.exports = __webpack_public_path__ + "img/checkout-icon.571877d8.svg";